module.exports = __webpack_public_path__ + "img/pr.e56fa4f6.svg";